// components/Layout.js
import React from "react";
import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";
import Header from "./components/page_components/home_layout_components/Header";
import Footer from "./components/page_components/home_layout_components/Footer";

const Layout = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "white",
      }}
    >
      <Header />

      {/* 👇 THIS is the key */}
      <Box sx={{ flex: 1 }}>
        <Outlet />
      </Box>

      <Footer />
    </Box>
  );
};

export default Layout;
